import md5 from 'md5';

// CDN base URL for Zelda Wiki images
const CDN_BASE_URL = 'https://cdn.wikimg.net/en/zeldawiki/images';

/**
 * Generates the MediaWiki-style hash path for a filename
 * MediaWiki uses MD5 hash of the filename to create directory structure
 * e.g., "TotK_Apple_Pie_Icon.png" -> "f/f4/TotK_Apple_Pie_Icon.png"
 * @param filename - The filename to hash
 * @returns The hash path (e.g., "f/f4")
 */
function getHashPath(filename: string): string {
  const hash = md5(filename);
  return `${hash.charAt(0)}/${hash.substring(0, 2)}`;
}

/**
 * Converts an item/dish name to CDN filename format
 * e.g., "Apple Pie" -> "TotK_Apple_Pie_Icon.png"
 * @param name - The display name (e.g., "Apple Pie")
 * @returns The CDN filename
 */
function nameToCdnFilename(name: string): string {
  const formatted = name.replace(/ /g, '_');
  return `TotK_${formatted}_Icon.png`;
}

/**
 * Generates the CDN URL for an image by name
 * @param name - The display name (e.g., "Apple Pie")
 * @returns The full CDN URL for the image
 */
export function getCdnUrlByName(name: string | undefined): string {
  if (!name) {
    return '';
  }
  const filename = nameToCdnFilename(name);
  const hashPath = getHashPath(filename);
  return `${CDN_BASE_URL}/${hashPath}/${filename}`;
}

/**
 * Creates a proxy object that generates CDN URLs for items on demand
 * Keys should be the item/dish name (e.g., "Apple Pie")
 */
export function createItemsProxy(): Record<string, string> {
  return new Proxy({} as Record<string, string>, {
    get: (_, key: string) => getCdnUrlByName(key),
  });
}
